
import React from 'react';
import {Action, TextLoading} from "../../client/funcs/utils";
import email_icon from "./email_icon.png";

const render_pershing = (name, acct_num) => {
  return (
    <div style={{marginLeft: "3rem"}}>
      Bank: The Bank of New York Mellon<br/>
      ABA Number: 021000018<br/>
      Beneficiary: Pershing, LLC<br/>
      Beneficiary Account Number: 8900512385<br/>
      Ultimate Beneficiary: <b>{name}</b><br/>
      Ultimate Beneficiary Account Number: <b>{acct_num}</b><br/>
      SWIFT Code: IRVTUS3N<br/>
      <div style={{height: "1rem"}}/>
      <div style={{display: "flex"}}>
        <div>Bank Address:</div>
        <div style={{width: "2rem"}}/>
        <div>
          <div>Pershing, LLC</div>
          <div>1 Wall Street</div>
          <div>New York, NY 10286</div>
        </div>
      </div>
    </div>
  )
}

const render_schwab = (name, acct_num) => {
  const line_0 = "To fund your Schwab Brokerage account from a U.S. bank, please provide your institution the following information:";
  const lines = [
    [ "Bank", "Citibank N.A., New York"],
    [ "Routing Number", "021000089" ],
    [ "FBO", "Charles Schwab & Co., Inc."],
    [ "Account Number", "4055-3953" ],
    [ "Bank Address", "399 Park Avenue, New York, NY 10022" ],
    [ "For further credit to", name + " " + acct_num ],
  ]

  const line_divs = lines.map((line, index) => {
    const label = line[0];
    const value = line[1];

    return (
      <div key={index}>
        <span style={{fontWeight: "bold"}}>{label}: </span>
        <span>{value}</span>
      </div>
    )
  })

  return (
    <div>
      <div>{line_0}</div>
      <div style={{height: "2rem"}}/>
      <div style={{ marginLeft: "2rem"}}>
        { line_divs }
      </div>
    </div>
  )
}


const WireInstructions = props => {
  const {acct_num, on_click, name, custodian} = props;
  const icon_style = {
    width: "7rem",
    paddingRight: "1rem",
    transform: "translate(0, 2rem)"
  };
  const container_style = {
    textAlign: "left",
  }
  const sending_email = props.sending_email;
  let inst_div;
  if (custodian === "PERSHING") {
    inst_div = render_pershing(name, acct_num);
  } else {
    inst_div = render_schwab(name, acct_num);
  }

  return (
    <div style={container_style}>
      <div>
        <img src={email_icon} alt={"email"} style={icon_style}/>
        <Action onClick={on_click}>
          <TextLoading
            label={"Email me these details"}
            loading={sending_email}/>
        </Action>
      </div>
      <div style={{height: "2rem"}}/>
      { inst_div }
    </div>
  )
}

export { WireInstructions };
